import React, { ReactElement } from 'react';

import { AfterSubmitFunc, FormRows, FormTemplate, SimpleBlock, SubmitFormFunc, TextInput } from 'ui-builder';
import { PlanTask, TeamPermission, ApiVersion } from 'nekst-api';
import Row3x3x6x from '../../../../shared/web/uitheme/form/Row3x3x6x';
import Checkbox from '../../../../shared/uibuilder/form/input/Checkbox';
import Separator from '../../../../shared/web/uitheme/form/Separator';
import RelativeRow, { EmptyCell } from '../../../../shared/web/uitheme/form/RelativeRow';
import { ValidationSchema } from '../../../../shared/uibuilder/validation';
import {
  EventPlanTaskTitleInput, EventPlanTaskSmartTagsWysiwyg,
  TasksGroupsDropdown,
  RoadmapDescription, PortalRoadmapCheckbox
} from 'features/tasks-forms';
import { PlanPermission, useAuthorizationChecker } from 'authorization-scope';
import EventInviteRecipientsInput from './EventInviteRecipientsInput';

export interface BaseEventTaskFormProps {
  title: string,
  submitFormFunc: SubmitFormFunc<PlanTask>,
  afterSubmitFunc?: AfterSubmitFunc,
  validationSchema: ValidationSchema,
  buttons?: ReactElement,
  initialData?: PlanTask
  planId: number
}

function CheckboxesRows() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TeamPermission.FEATURE_BUSINESS_DAYS)) {
    return (
      <FormRows>
        <RelativeRow weights={[2.5, 2, 4, 3.5]}>
          <Checkbox source="isKeyDate" label="Key Date" />
          <Checkbox source="isPrivate" label="Private" />
          <PortalRoadmapCheckbox />
          <EmptyCell />
        </RelativeRow>
      </FormRows>
    );
  } else {
    return (
      <FormRows>
        <Row3x3x6x>
          <Checkbox source="isKeyDate" label="Key Date" />
          <Checkbox source="isPrivate" label="Private" />
          <PortalRoadmapCheckbox />
        </Row3x3x6x>
      </FormRows>
    );
  }
}

export default function BaseEventTaskForm(props: BaseEventTaskFormProps) {
  const { isGranted } = useAuthorizationChecker();

  return (
    <FormTemplate<PlanTask & { copyRoadmapDescription?: boolean }>
      submitFormFunc={props.submitFormFunc}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={props.validationSchema}
      title={props.title}
      buttons={props.buttons}
      initialData={{
        copyRoadmapDescription: !props.initialData?.roadmapDescription,
        ...props.initialData || {},
        _version: isGranted(TeamPermission.FEATURE_BUSINESS_DAYS) ? ApiVersion.IF_WEEKEND_SHIFT : undefined
      }}
      isDisabled={!isGranted(PlanPermission.UPDATE)}
    >
      <SimpleBlock>
        <EventPlanTaskTitleInput
          source="name"
          label="Appointment Name"
          planId={props.planId}
        />
      </SimpleBlock>
      <CheckboxesRows />
      <EventPlanTaskSmartTagsWysiwyg source="description" label="Appointment Description" planId={props.planId} />
      <RoadmapDescription />
      <Separator />
      <RelativeRow weights={[6, 6]}>
        <TasksGroupsDropdown source="groupId" label="Group" planId={props.planId} />
        <TextInput source="location" label="Location" />
      </RelativeRow>
      <Separator />
      <EventInviteRecipientsInput planId={props.planId} />
    </FormTemplate>
  );
}
